
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { State } from 'vuex-class'

import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue'
import AppSearchBtn from '@/components/AppSearchBtn.vue'
import AppSimpleSelector from '@/components/AppSimpleSelector.vue'
import AppSimpleTextField from '@/components/AppSimpleTextField.vue'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { utcDateTimeToLocal, formatWeixinDate } from '@/utils/dateTime'
import ListPage from '@/mixins/list-page'
import { getWeixinRefund, handleRefundAudit } from './gql'
import { findAllPeriod } from '../OrderList/gql'
import { Refund, RefundsOrderBy } from '@/interfaces/refund'
import { TypedGqlError } from '@/interfaces/error'
import AuditDialog from './pages/AuditDialog.vue'
import AuthFilter from '@/mixins/auth-filter'
import { findDealers } from '@/views/DealerList/gql'
import { auditStatusText, auditOptions, auditCodes } from '@/helpers/audit'
import AppSimpleSearchSelector from '@/components/AppSimpleSearchSelector.vue'
import { formatCurrency } from '@/utils/currency'
import { AuditStatus } from '@/interfaces/status'
import { exportRefundsList } from '../RefundList/gql'
import { downloadBase64 } from '@/helpers/base64-to-file'
import { dispatchUpdateIfNewOrders } from '../../store/dispatches'

@Component({
  components: {
    AppBreadcrumbs,
    AppRefreshAndExport,
    AppDialog,
    AppSimpleTextField,
    AppSimpleSelector,
    AppSearchBtn,
    AppTextField,
    AuditDialog,
    AppSimpleSearchSelector
  }
})
export default class RefundList extends mixins(ListPage, AuthFilter) {
  @State(state => state.page.RefundList) cache!: string
  breadcrumbs: Breadcrumb[] = [
    {
      text: '订单管理'
    }, {
      text: '线上退款审核'
    }
  ]

  formatCurrency = formatCurrency
  utcDateTimeToLocal = utcDateTimeToLocal
  formatWeixinDate = formatWeixinDate
  refunds: Refund[] = []

  selectedRefund: Refund | null = null
  selectedOrders: Refund[] = []
  disabledActions = true

  options = {
    sortBy: ['auditStatus'],
    page: 1,
    itemsPerPage: 10,
    sortDesc: [true]
  }

  dealerOptions: any[] = []

  filter = {
    dealerId: {
      id: null,
      label: ''
    },
    orderNumber: null,
    refundNumber: null,
    phone: null,
    auditStatus_EQ: -1
  }

  totalNum = 0
  loading = false

  headers = [
    { text: '审核状态', value: 'auditStatus', width: 120 },
    { text: '退款编号', value: 'refundNumber' },
    { text: '经销商', value: 'order.dealer.realname', sortable: false, width: 150 },
    { text: '订单编号', value: 'order.orderNumber', width: 200, sortable: false },
    { text: '付款时间', value: 'order.timeEnd', width: 200, sortable: false },
    { text: '订单金额', value: 'totalPrice', width: 120 },
    { text: '学生姓名', value: 'order.address.realname', width: 140, sortable: false },
    { text: '支付用户手机号', value: 'order.address.phone', sortable: false }
  ]

  refundPassDialog = {
    show: false,
    text: '你确定要通过审核吗？'
  }

  refundRejectDialog = {
    show: false,
    text: '你确定要拒绝审核吗？'
  }

  refundDetailDialog = {
    show: false,
    title: '详情',
    disable: false,
    confirmText: '通过',
    cancelText: '拒绝'
  }

  windowSize = {
    w: 0,
    h: 0
  }

  AuditStatusText = auditStatusText
  auditStatusCode = auditCodes()
  auditStatusOptions = auditOptions()

  confirmDialog = {
    show: false,
    title: '',
    text: ''
  }

  @Watch('options', { deep: true })
  onOptionsChanged () {
    this.getRefunds()
  }

  @Watch('selectedOrders', { deep: true, immediate: true })
  onSelectedOrdersChanged (val: any) {
    const filteredList = val.filter((item: any) => item.auditStatus === 'PENDING')

    this.disabledActions = !filteredList.length
  }

  mounted () {
    this.onResize()
    this.restorePage(this.cache)
    this.getRefunds()
    this.getDealerOptions()
  }

  // 获取经销商option
  async getDealerOptions (query?: { take: number; model: string }) {
    const where = query && query.model ? { realname: query.model } : null
    const take = query && query.take ? query.take : 20
    try {
      const result = await this.$apollo.query({
        query: findDealers,
        variables: {
          order: null,
          paging: {
            skip: 0,
            take
          },
          where
        }
      })
      if (result.data.findDealers) {
        this.dealerOptions = result.data.findDealers.dealers.map((option: any) => {
          return {
            id: option.id,
            label: option.realname
          }
        })
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 获取订单列表
  async getRefunds () {
    const { sortBy, page, itemsPerPage, sortDesc } = this.options
    const { dealerId, orderNumber, refundNumber, phone, auditStatus_EQ } = this.filter
    const by = RefundsOrderBy[sortBy[0] || 'createdAt']
    const asc = sortDesc[0] || false
    this.loading = true
    const order = { by, asc }
    const paging = {
      skip: itemsPerPage * (page - 1),
      take: itemsPerPage
    }
    const where = {
      dealerId_OF_order: dealerId ? dealerId.id : null,
      orderNumber_OF_order: orderNumber || null,
      refundNumber: refundNumber || null,
      phone_OF_order: phone || null,
      auditStatus_EQ: this.auditStatusCode[auditStatus_EQ] || null
    }
    const result = await this.queryRefundsRequest(order, paging, where)
    if (result) {
      this.refunds = result.refunds
      this.totalNum = result.paging.totalCount
    }
    this.loading = false
    this.storePage()
    dispatchUpdateIfNewOrders({
      refundAudit: false
    })
  }

  async queryAllPeriod () {
    try {
      const result = await this.$apollo.query({
        query: findAllPeriod
      })
      return result.data.findAllUsedPeriodSettings
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async queryRefundsRequest (order: any, paging: any, where: any) {
    try {
      const result = await this.$apollo.query({
        query: getWeixinRefund,
        variables: {
          order,
          paging,
          where
        }

      })
      return result.data.findWeixinRefunds
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async queryRefundAudit (isApprove: boolean, orderIds: number[]) {
    try {
      const result = await this.$apollo.mutate({
        mutation: handleRefundAudit,
        variables: {
          orderIds,
          approve: isApprove
        }
      })
      return result
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  handlePass (item: Refund) {
    this.selectedRefund = item
    this.refundPassDialog.show = true
  }

  handleReject (item: Refund) {
    this.selectedRefund = item
    this.refundRejectDialog.show = true
  }

  handleAuditConfirm (isPass: boolean) {
    const orderIds = this.selectedOrders.reduce((prev: number[], curr) => {
      if (curr.auditStatus === AuditStatus.PENDING) {
        prev.push(curr.orderId)
      }
      return prev
    }, [])

    return isPass ? this.refundPassConfirm(orderIds) : this.refundRejectConfirm(orderIds)
  }

  async refundPassConfirm (orderIds: number[]) {
    this.refundPassDialog.show = false
    this.refundDetailDialog.show = false
    const result = await this.queryRefundAudit(true, orderIds)
    if (result) {
      this.selectedOrders = []
      showNotification({
        msg: '操作成功',
        type: SnackType.Success
      })
      this.getRefunds()
    }
  }

  refundPassCancel () {
    this.refundPassDialog.show = false
  }

  async refundRejectConfirm (orderIds: number[]) {
    this.refundRejectDialog.show = false
    this.refundDetailDialog.show = false
    const result = await this.queryRefundAudit(false, orderIds)
    if (result) {
      this.selectedOrders = []
      showNotification({
        msg: '操作成功',
        type: SnackType.Success
      })
      this.getRefunds()
    }
  }

  refundRejectCancel () {
    this.refundRejectDialog.show = false
  }

  // 详情
  showAuditDetail (item: Refund) {
    this.selectedRefund = item
    this.refundDetailDialog.show = true
  }

  auditDetailCancel () {
    this.refundDetailDialog.show = false
  }

  filterQuerySubmit () {
    this.getRefunds()
  }

  refreshList () {
    this.filter = {
      dealerId: {
        id: null,
        label: ''
      },
      orderNumber: null,
      refundNumber: null,
      phone: null,
      auditStatus_EQ: -1
    }
    this.getRefunds()
  }

  async exportHandler () {
    showNotification({
      msg: '即将开始下载...',
      type: SnackType.Info
    })
    const { sortBy, sortDesc } = this.options
    const {
      dealerId,
      orderNumber,
      refundNumber,
      phone,
      auditStatus_EQ
    } = this.filter
    const by = RefundsOrderBy[sortBy[0] || 'createdAt']
    const asc = !sortDesc[0] || false
    this.loading = true
    const order = { by, asc }
    const where = {
      dealerId_OF_order: dealerId ? dealerId.id : null,
      orderNumber_OF_order: orderNumber || null,
      refundNumber: refundNumber || null,
      phone_OF_order: phone || null,
      auditStatus_EQ: this.auditStatusCode[auditStatus_EQ] || null
    }
    try {
      const result = await this.$apollo.query({
        query: exportRefundsList,
        variables: {
          order,
          where
        }
      })
      if (result.data) {
        const { fileName, contentB64 } = result.data.exportRefundsList
        downloadBase64(contentB64, fileName)
      }
      this.loading = false
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
    const actionDom = this.$refs.actions as Vue & {
      clientHeight: number;
    }
    this.actionsHeight = actionDom.clientHeight
  }
}
